<template>
	<div v-if="widgetReady" class="row">
		<div class="col-lg-4">
			<p class="referral-required-hint">
				<small><span class="redText">required</span></small>
			</p>
			<label for="referral-survey-select" class="referral-sr-only">How did you hear about us?</label>
			<select id="referral-survey-select" class="form-control" v-model="vm.mainModel.referralAnswer">
                <option v-for="opt in options" :value="opt.optionId">
                    {{ opt.name }}
                </option>
            </select>
		</div>
	</div>
</template>

<script>
    import {configTables} from "@/global/configTables.js";

	export default {
		name: "ReferralSurvey",
        props: {
            value: { type: Object, required: true },
        },
        data() {
            return {
                vm: { ...this.value },
                options: [],                
				widgetReady: false
            };
        },
        async mounted() {
            this.options = await configTables.getReferralSurveyOptions();
            this.widgetReady = true;
        }
	}
</script>

<style scoped>
    .referral-sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
    }
    .referral-required-hint {
        margin: 0 0 8px 0;
    }
    /* If we wanted to show the dropdown arrow for dropdown list; uncomment*/
    /* .form-control{
        -webkit-appearance: auto;
        -moz-appearance: auto;
        appearance: auto;
    } */
     .redText{
        font-size: 0.875em;
        font-weight: 400;
     }
</style>